export default {
  items: [],
  searchQuery: '',
  hasMore: true,
  hasRegistryItems: false,
  isLoading: false,
  isPageLoading: false,
  isLoaded: false,
  error: null,
  processingIds: [],
};
